const masks = [
	/^(-?\d{1,3})(\d{3})?(\d{3})?(\.\d{1,20})?$|^(-?\d{1,3})(\.?\d{3})?(\.?\d{3})?(,\d{1,20})?$/,	// Dec
	/^(-?\d{1,3})(\d{3})?(\d{3})?$|^(-?\d{1,3})(\.?\d{3})?(\.?\d{3})?$/,							// Int
	/^(\d{1,3})(\d{3})?(\d{3})?$|^(\d{1,3})(\.?\d{3})?(\.?\d{3})?$/,								// Pos
];

/** Grupos do replace podem vir como número (API/DOM); .replace exige string. */
const _s = (v) => (v != null && v !== '' ? String(v) : '');

const store = function(g1, g2, g3, g4)
{
	const dec = _s(g4);
	return 	String(g1 ?? '') +
			_s(g2).replace(this.ts, '') +
			_s(g3).replace(this.ts, '') +
			(this.dp ? '.' + ((dec.length ? dec.slice(1) : '') + '000000').slice(0, this.dp) : '');
};

const display = function(g1, g2, g3, g4)
{
	const s2 = _s(g2);
	const s3 = _s(g3);
	const dec = _s(g4);
	return 	String(g1 ?? '') +
			(s2 ? this.ts + s2.replace(/[.,]/, '') : '') +
			(s3 ? this.ts + s3.replace(/[.,]/, '') : '') +
			(this.dp ? this.ds + ((dec.length ? dec.slice(1) : '') + '000000').slice(0, this.dp) : '');
};

export default function (...args)	// decimal_places, regex_option, decimal_separator, thousands_separator
{
	return {
		dp: args[0] ?? 0,		// Decimal places
		ds: args[2] ?? ',',		// Decimal separator
		ts: args[3] ?? '.',		// Thousands separator
		regex: masks[args[1] ?? 0],
		store_mask(match, a1, a2, a3, a4, b1, b2, b3, b4)
		{
			return (a1 ? store.call(this, a1, a2, a3, a4) : store.call(this, b1, b2, b3, b4));
		},
		display_mask(match, a1, a2, a3, a4, b1, b2, b3, b4)
		{
			return (a1 ? display.call(this, a1, a2, a3, a4) : display.call(this, b1, b2, b3, b4));
		}
	};
}

